import styled from 'styled-components';
import { color, space, layout, flexbox } from 'styled-system';

import Box from './Box';

const Flex = styled(Box)({ display: 'flex' }, space, layout, flexbox, color);

Flex.displayName = 'Flex';

export default Flex;
